export default __webpack_public_path__ + "static/media/button_exit.490e05f0.svg";